const LOGIN = "LOGIN";
const LOGOUT = "LOGOUT";
const GET_APPLICATION_VERSION = "GET_APPLICATION_VERSION";
const GET_USER = "GET_USER";
const GET_ADMIN_USERS = "GET_ADMIN_USERS";
const GET_VIP_USERS = "GET_VIP_USERS";
const SET_BLOB_SETTINGS = "SET_BLOB_SETTINGS";
const SET_LOADED = "SET_LOADED";

export {
    LOGIN,
    LOGOUT,
    GET_APPLICATION_VERSION,
    GET_USER,
    GET_ADMIN_USERS,
    GET_VIP_USERS,
    SET_BLOB_SETTINGS,
    SET_LOADED,
};
